import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Menu, Button, Drawer } from 'antd';
import { MenuOutlined } from '@ant-design/icons';

const HeaderContainer = styled.header`
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 100;
`;

const HeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
  height: 64px;
  max-width: 1200px;
  margin: 0 auto;
`;

const Logo = styled(Link)`
  font-size: 1.5rem;
  font-weight: bold;
  color: #333;
  display: flex;
  align-items: center;
  
  &:hover {
    color: #1890ff;
  }
`;

const DesktopMenu = styled(Menu)`
  border: none;
  @media (max-width: 768px) {
    display: none;
  }
`;

const MobileMenuButton = styled(Button)`
  display: none;
  @media (max-width: 768px) {
    display: block;
  }
`;

const Header: React.FC = () => {
  const [visible, setVisible] = useState(false);

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };

  const menuItems = [
    { key: '/', label: '首页' },
    { key: '/ai-coding', label: 'AI编码' },
    { key: '/ai-creation', label: 'AI创作' },
    { key: '/knowledge', label: '知识链接' },
    { key: '/about', label: '关于我' },
  ];

  return (
    <HeaderContainer>
      <HeaderContent>
        <Logo to="/">谦言万语</Logo>
        <DesktopMenu mode="horizontal" defaultSelectedKeys={['/']} items={menuItems} />
        <MobileMenuButton type="text" icon={<MenuOutlined />} onClick={showDrawer} />
        <Drawer
          title="谦言万语"
          placement="right"
          onClose={onClose}
          open={visible}
          bodyStyle={{ padding: 0 }}
        >
          <Menu
            mode="vertical"
            defaultSelectedKeys={['/']}
            items={menuItems}
            onClick={onClose}
          />
        </Drawer>
      </HeaderContent>
    </HeaderContainer>
  );
};

export default Header; 